import { connect } from 'react-redux'

import { fetchGalleryImages, resetLoaded, uploadImage } from 'store/entities/gallery/actions'
import { getGalleryLoaded } from 'store/entities/gallery/selectors'
import { getIdentityOrganizationId } from 'store/entities/identity/selectors'
import { modal } from 'store/entities/modal/actions'
import GalleryItemsComponent from './GalleryItems'
import ImageInput from 'app/components/Inputs/ImageInput'
import Gallery from 'app/components/Gallery'
import { GALLERY_INNER_MODIFIER } from 'app/constants/gallery'

import './styles.scss'

const mapStateToProps = (state, ownProps) => ({
  galleryImages: GALLERY_INNER_MODIFIER[ownProps.innerModifier](state),
  loaded: getGalleryLoaded(state),
  GalleryItemsComponent,
  GalleryInput: ImageInput,
  organizationId: getIdentityOrganizationId(state),
})

const mapDispatchToProps = {
  getItems: fetchGalleryImages,
  uploadImageRequest: uploadImage,
  reset: resetLoaded,
  showModal: modal.show,
}

const mergeProps = ({ organizationId, ...restState }, { getItems, ...restDispatch }, restOwn) => ({
  ...restState,
  ...restDispatch,
  ...restOwn,
  getItems: () => getItems(organizationId),
})

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(Gallery)
